module.exports = __webpack_public_path__ + "static/media/KaTeX_Caligraphic-Regular.5e7940b4.ttf";